import {
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
  useElements
} from '@stripe/react-stripe-js'
import React from 'react'
import { translate } from '~/core/translate'

import Button from '@8x8/oxygen-button'

import {
  ButtonContainer,
  FieldWrapper,
  Footer,
  Label
} from './styled'

const style = {
  base: {
    fontWeight: 600,
    fontSize: '16px',
    fontSmoothing: 'antialiased',
    '::placeholder': {
      color: '#CFD7DF'
    },

    ':-webkit-autofill': {
      color: '#e39f48'
    }
  },
  invalid: {
    color: '#E25950',

    '::placeholder': {
      color: '#FFCCA5'
    }
  }
}

export default ({
  onChange,
  onSubmit,
  submitDisabled
}) => {
  const elements = useElements()

  const onSubmitPaymentMethod = () => {
    const cardElement = elements.getElement(CardNumberElement)
    onSubmit(cardElement)
  }

  return (
    <>
      <Label>
        {`${translate('card_number')}:`}
      </Label>
      <FieldWrapper>
        <CardNumberElement
          onChange={onChange}
          options={{
            style: style,
            showIcon: true
          }}
        />
      </FieldWrapper>
      <Label>
        {`${translate('card_expiration_date')}:`}
      </Label>
      <FieldWrapper percent={33}>
        <CardExpiryElement
          onChange={onChange}
          options={{
            style: style
          }}
        />
      </FieldWrapper>
      <Label>
        {`${translate('card_cvc')}:`}
      </Label>
      <FieldWrapper percent={33}>
        <CardCvcElement
          onChange={onChange}
          options={{
            style: style
          }}
        />
      </FieldWrapper>
      <Footer>
        {translate('card_info_notice')}
      </Footer>
      <ButtonContainer>
        <Button
          onClick={onSubmitPaymentMethod}
          disabled={submitDisabled}
        >
          {translate('change_payment_details')}
        </Button>
      </ButtonContainer>
    </>
  )
}
